<template>
  <el-drawer
    :visible.sync="visible"
    :direction="direction"
    :showClose="showClose"
    :size="size"
    :appendToBody="appendToBody"
    :wrapperClosable="wrapperClosable">

    <div class="pv-drawer-title" slot="title">
      <div class="title-text">{{ title }}</div>
      <div class="ctrl-btns">
        <el-button size="mini" @click="hide">取消</el-button>
        <el-button size="mini" type="primary" @click="submit" :loading="submitting">确定</el-button>
      </div>
    </div>
    <div class="pv-drawer-content" v-if="visible">
      <slot></slot>
    </div>

  </el-drawer>
</template>
<script>

export default {
  components: {},
  props: {
    title: String,
    wrapperClosable: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'rtl'
    },
    size: {
      type: [String, Number],
      default: 450
    },
    appendToBody: Boolean
  },
  data() {
    return {
      visible: false,
      submitting: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    show() {
      this.visible = true;
    },
    hide() {
      this.$emit('close');
      this.visible = false;
    },
    submit() {
      this.submitting = true;
      const callback = () => {
        this.submitting = false;
      };
      this.$emit('submit', callback);
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  }
}
</script>

<style lang="scss" scoped>
.pv-drawer-title {
  .title-text {
    display: inline-block;
    line-height: 28px;
  }

  .ctrl-btns {
    float: right;
  }
}
</style>
